
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const CTASection: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-[#0d1117] text-white relative overflow-hidden w-full">
      <div className="container mx-auto px-6 text-center relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Ready to Join <span className="text-sports-green">Players Lockeroom?</span>
        </h2>
        <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
          Create your account today and connect with your sports community.
        </p>
        <Button asChild className="bg-sports-green hover:bg-sports-green/90 text-black font-bold px-8 py-6 h-auto text-lg rounded-md">
          <Link to="/register" className="flex items-center">
            Get Started Now
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default CTASection;
